import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'Common/ReactTableWrapper';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

export class ServedItemsTable extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    cogOptions: PropTypes.array.isRequired,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  columns = [
    {
      Header: 'Item Id',
      accessor: 'Id',
      filterable: true,
      maxWidth: 70,
    },
    {
      Header: 'Item Description',
      accessor: 'Description',
      filterable: true,
      minWidth: 300,
    },
    {
      Header: 'Short Description',
      accessor: 'ShortDescription',
      filterable: true,
      minWidth: 150,
    },
    {
      Header: 'Nutrition Code',
      accessor: 'NutritionCode',
      filterable: true,
    },
    {
      Header: 'Alternate Item',
      accessor: 'AlternateId',
      filterable: true,
    },
    {
      Header: 'Item Category',
      accessor: 'POS_ItemCategory.Description',
      filterable: true,
    },
    {
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.props.cogOptions,
        });
      },
    },
  ];

  render() {
    return (
      <ReactTable
        menu={'hasCogs'}
        saveState={{ tableName: TableNamesEnum.SERVED_ITEM_SETUP_TABLE }}
        loading={this.props.loading}
        data={this.props.data}
        columns={this.columns}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/components/ServedItemsTable.js